var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadtrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 661,
    height: 31,
    viewBox: "0 0 661 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 660.139,
    height: 4.28662,
    transform: "translate(0 25.9199)",
    fill: "#D9DBE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.9204H116.719V30.207H0V25.9204Z",
    fill: "#EECCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 25.9204H11.0738L8.57323 30.207H0V25.9204Z",
    fill: "#D9A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4302 25.9204H27.8612L25.3607 30.207H13.9297L16.4302 25.9204Z",
    fill: "#D9A3A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2193 25.9204H44.6503L42.1497 30.207H30.7188L33.2193 25.9204Z",
    fill: "#D9A3A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0122 25.9204H61.4432L58.9427 30.207H47.5117L50.0122 25.9204Z",
    fill: "#D9A3A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8013 25.9204H78.2323L75.7318 30.207H64.3008L66.8013 25.9204Z",
    fill: "#D9A3A3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5904 25.9204H95.0213L92.5208 30.207H81.0898L83.5904 25.9204Z",
    fill: "#D9A3A3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M100.379 25.9204H111.81L109.31 30.207H97.8789L100.379 25.9204Z",
    fill: "#D9A3A3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M117.168 25.9204H128.599L126.099 30.207H114.668L117.168 25.9204Z",
    fill: "#A0A3BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.958 25.9204H145.389L142.888 30.207H131.457L133.958 25.9204Z",
    fill: "#A0A3BD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.747 25.9204H162.178L159.677 30.207H148.246L150.747 25.9204Z",
    fill: "#A0A3BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.536 25.9204H178.967L176.466 30.207H165.035L167.536 25.9204Z",
    fill: "#A0A3BD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.325 25.9204H195.756L193.255 30.207H181.824L184.325 25.9204Z",
    fill: "#A0A3BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.114 25.9204H212.545L210.044 30.207H198.613L201.114 25.9204Z",
    fill: "#A0A3BD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M217.903 25.9204H229.334L226.833 30.207H215.402L217.903 25.9204Z",
    fill: "#A0A3BD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.692 25.9204H246.123L243.622 30.207H232.191L234.692 25.9204Z",
    fill: "#A0A3BD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.481 25.9204H262.912L260.411 30.207H248.98L251.481 25.9204Z",
    fill: "#A0A3BD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M268.27 25.9204H279.701L277.201 30.207H265.77L268.27 25.9204Z",
    fill: "#A0A3BD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M285.059 25.9204H296.49L293.99 30.207H282.559L285.059 25.9204Z",
    fill: "#A0A3BD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M301.848 25.9204H313.279L310.779 30.207H299.348L301.848 25.9204Z",
    fill: "#A0A3BD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M318.637 25.9204H330.068L327.568 30.207H316.137L318.637 25.9204Z",
    fill: "#A0A3BD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M335.426 25.9204H346.857L344.357 30.207H332.926L335.426 25.9204Z",
    fill: "#A0A3BD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M352.215 25.9204H363.646L361.146 30.207H349.715L352.215 25.9204Z",
    fill: "#A0A3BD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M369.004 25.9204H380.435L377.935 30.207H366.504L369.004 25.9204Z",
    fill: "#A0A3BD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M385.797 25.9204H397.228L394.728 30.207H383.297L385.797 25.9204Z",
    fill: "#A0A3BD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M402.586 25.9204H414.017L411.517 30.207H400.086L402.586 25.9204Z",
    fill: "#A0A3BD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M419.372 25.9204H430.803L428.302 30.207H416.871L419.372 25.9204Z",
    fill: "#A0A3BD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M436.165 25.9204H447.596L445.095 30.207H433.664L436.165 25.9204Z",
    fill: "#A0A3BD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M452.954 25.9204H464.385L461.884 30.207H450.453L452.954 25.9204Z",
    fill: "#A0A3BD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M469.743 25.9204H481.174L478.673 30.207H467.242L469.743 25.9204Z",
    fill: "#A0A3BD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M486.532 25.9204H497.963L495.462 30.207H484.031L486.532 25.9204Z",
    fill: "#A0A3BD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M503.321 25.9204H514.752L512.251 30.207H500.82L503.321 25.9204Z",
    fill: "#A0A3BD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M520.11 25.9204H531.541L529.04 30.207H517.609L520.11 25.9204Z",
    fill: "#A0A3BD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M536.899 25.9204H548.33L545.829 30.207H534.398L536.899 25.9204Z",
    fill: "#A0A3BD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M553.688 25.9204H565.119L562.618 30.207H551.188L553.688 25.9204Z",
    fill: "#A0A3BD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M570.477 25.9204H581.908L579.408 30.207H567.977L570.477 25.9204Z",
    fill: "#A0A3BD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M587.266 25.9204H598.697L596.197 30.207H584.766L587.266 25.9204Z",
    fill: "#A0A3BD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M604.055 25.9204H615.486L612.986 30.207H601.555L604.055 25.9204Z",
    fill: "#A0A3BD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M620.844 25.9204H632.275L629.775 30.207H618.344L620.844 25.9204Z",
    fill: "#A0A3BD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M637.633 25.9204H649.064L646.564 30.207H635.133L637.633 25.9204Z",
    fill: "#A0A3BD"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M654.422 25.9204H660.138V30.207H651.922L654.422 25.9204Z",
    fill: "#A0A3BD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 105.734,
    y: 0.199219,
    width: 6.07271,
    height: 6.07271,
    fill: "#EFF0F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 105.734,
    y: 6.27295,
    width: 6.07271,
    height: 6.07271,
    fill: "#4E4B66"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 105.734,
    y: 12.3472,
    width: 6.07271,
    height: 6.07271,
    fill: "#EFF0F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 105.734,
    y: 18.417,
    width: 6.07271,
    height: 6.07271,
    fill: "#4E4B66"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 105.734,
    y: 24.4893,
    width: 6.07271,
    height: 6.07271,
    fill: "#EFF0F6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 111.809,
    y: 0.199219,
    width: 6.07271,
    height: 6.07271,
    fill: "#4E4B66"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 111.809,
    y: 6.27295,
    width: 6.07271,
    height: 6.07271,
    fill: "#EFF0F6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 111.809,
    y: 12.3472,
    width: 6.07271,
    height: 6.07271,
    fill: "#4E4B66"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 111.809,
    y: 18.417,
    width: 6.07271,
    height: 6.07271,
    fill: "#EFF0F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 111.809,
    y: 24.4893,
    width: 6.07271,
    height: 6.07271,
    fill: "#4E4B66"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 647,
    y: 19,
    width: 13.0416,
    height: 11.1111,
    fill: "#4E4B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadtrip);
export default __webpack_public_path__ + "static/media/roadtrip.fa7cbfeee70b3fbab22015daf6d65109.svg";
export { ForwardRef as ReactComponent };